import React from 'react';
import { IProps } from './interfaces';

const KrPickeball: React.FC<IProps> = ({
  size = 32,
  color = '#FF6900',
  className,
}) => {
  return (
    <svg
      id="Capa_1"
      width={size}
      height={size}
      className={className}
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M31.06,27.3l-1.26-.92-5.77-5.46-.82-9.48c-.08-.95-.5-1.85-1.18-2.53L14.62,1.49C13.62.5,12.3-.05,10.89-.05s-2.73.55-3.73,1.54l-3.37,3.37s-.03.05-.05.07l-2.2,2.2C.54,8.14,0,9.46,0,10.87s.55,2.73,1.54,3.73l7.41,7.41c.68.68,1.57,1.09,2.52,1.18l9.48.82,5.45,5.76.92,1.26c.34.47.86.76,1.44.81.05,0,.1,0,.15,0,.52,0,1.02-.21,1.39-.58l.38-.38.59-.59c.41-.41.62-.97.57-1.55s-.34-1.1-.81-1.44ZM10.23,20.74l-7.41-7.41c-.66-.66-1.02-1.53-1.02-2.46s.36-1.8,1.02-2.46l3.37-3.37s.03-.05.05-.07l2.21-2.2c1.35-1.35,3.56-1.35,4.91,0l7.41,7.41c.38.38.61.88.66,1.41l.8,9.31-1.3,1.3-9.29-.8c-.53-.05-1.03-.28-1.41-.66ZM28.91,30.04s-.09-.02-.12-.07l-.95-1.31-5.25-5.55.55-.55,5.46,5.17,1.4,1.03c.05.04.07.09.07.12s0,.09-.05.13l-.38.38-.21.21-.38.38s-.1.05-.13.05Z"
      />
      <path
        fill={color}
        d="M2.61,23.87c-.73.73-1.14,1.71-1.14,2.74s.4,2.01,1.14,2.74,1.75,1.13,2.74,1.13,1.99-.38,2.74-1.13c1.51-1.51,1.51-3.98,0-5.49s-4.02-1.47-5.49,0ZM7.25,28.51c-1.04,1.05-2.74,1.05-3.79,0-.51-.51-.79-1.18-.79-1.9s.28-1.39.79-1.9,1.18-.79,1.9-.79,1.39.28,1.9.79c1.04,1.04,1.04,2.75,0,3.79Z"
      />
    </svg>
  );
};

export default KrPickeball;
